// @flow

import * as React from 'react';
import { css } from '@emotion/core';
import styled from '@emotion/styled';

import InnerPage from "../../Core/components/InnerPage";
import {
  PrimaryLink
} from "../../Core/components/Buttons";
import padding from '../../Styles/padding';
import colors from '../../Styles/colors';
import { fontSize } from "../../Styles/text";

type Props = {||};

export default React.memo<Props>(function Fallback() {
  let page = css`
    background: ${colors.coreColor2};
  `;

  let wrapper = css`
    max-width: 600px;
    margin: ${padding.large} auto;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  `;

  let Message = styled('p')`
    ${fontSize(4)};
  `;

  return <InnerPage css={page}>
    <div css={wrapper}>
      <Message>
        It looks like you’re using an older browser that is no longer supported.
        You can access the <a href="/schedule/v1/">TPT schedule here</a>.
      </Message>
      <PrimaryLink href="/schedule/v1/">View TPT Schedule</PrimaryLink>
    </div>
  </InnerPage>;
})